import { addDoc, collection } from "firebase/storage";
import { db } from "./firebase";

const LAUNCH_COLLECTION = "launch";

export const saveLaunchEmail = async (launchEmail) => {
  await addDoc(collection(db, LAUNCH_COLLECTION), {
    email: launchEmail,
  });
};
